import { database } from "../firebase";
import * as moment from "moment";
import { auth } from "firebase";

export const retrieveCommunicationChannels = async (info) => {
  try {
    const channelsList = [];
    const allChannels = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("channels")
      .get();
    if (allChannels.size > 0) {
      await Promise.allSettled(
        allChannels.docs.map(async (channel) => {
          if (channel.exists) {
            const single = await fetchChannel(
              channel.id,
              channel.data(),
              info.companyId
            );
            if (typeof single !== "undefined") channelsList.push(single);
          }
        })
      ).catch((e) => {
        throw new Error("Kunne ikke hente kanaler.");
      });
      return Promise.all(channelsList).then((result) => {
        return { error: null, payload: result };
      });
    } else {
      return { error: "error", payload: [] };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchChannel = async (channelId, channel, companyId) => {
  try {
    const user = await database.collection("users").doc(channel.addedBy).get();
    if (user.exists) {
      if (channel.type === "email") {
        const request = await fetch(
          `/api/sendgrid/fetch-status/${companyId}/${channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const status = await request.json();

        if (status.error === null) {
          return {
            timestamp: channel.timestamp,
            type: channel.type,
            id: channelId,
            username: channel.username,
            active: status.payload,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
          };
        } else {
          throw "Error";
        }
      } else {
        const request = await fetch(
          `/api/twilio/fetch-status/${companyId}/${channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const status = await request.json();

        if (status.error === null) {
          return {
            timestamp: channel.timestamp,
            type: channel.type,
            id: channelId,
            username: channel.username,
            active: status.payload,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
          };
        } else {
          throw "Error";
        }
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveEmailChannelCredits = async (details) => {
  try {
    if (details.companyId && details.channelId) {
      if (details.type === "email") {
        const request = await fetch(
          `/api/sendgrid/fetch-credits/${details.companyId}/${details.channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const response = await request.json();

        if (!response.error && Object.keys(response.payload).length > 0) {
          return { error: null, payload: response.payload };
        } else {
          throw "Kunne ikke hente kreditt.";
        }
      } else {
        const request = await fetch(
          `/api/twilio/fetch-credits/${details.companyId}/${details.channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const response = await request.json();

        if (!response.error && Object.keys(response.payload).length > 0) {
          return { error: null, payload: response.payload };
        } else {
          throw "Kunne ikke hente kreditt.";
        }
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveEmailChannelStatistics = async (details) => {
  try {
    if (details.companyId && details.channelId && details.date) {
      const request = await fetch(
        `/api/sendgrid/fetch-statistics/${details.companyId}/${details.channelId}/${details.date}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();

      if (!response.error && Object.keys(response.payload).length > 0) {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke hente statistikk.";
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveEmailChannelReputation = async (details) => {
  try {
    if (details.companyId && details.channelId) {
      const request = await fetch(
        `/api/sendgrid/fetch-reputation/${details.companyId}/${details.channelId}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();

      if (!response.error) {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke hente statistikk.";
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveChannelSource = async (details) => {
  try {
    if (details.companyId && details.channelId && details.username) {
      if (details.type === "email") {
        const channel = await database
          .collection("companies")
          .doc(details.companyId)
          .collection("channels")
          .doc(details.channelId)
          .get();
        const domain = await database
          .collection("companies")
          .doc(details.companyId)
          .collection("channels")
          .doc(details.channelId)
          .collection("domain")
          .doc("information")
          .get();

        if (domain.exists) {
          const id = domain.data().id;

          if (details.username && id) {
            const data = {
              id: id,
              username: details.username,
            };

            const request = await fetch("/api/sendgrid/validate-domain", {
              method: "POST",
              body: JSON.stringify(data),
              headers: { "Content-Type": "application/json" },
            });
            const response = await request.json();

            if (
              response.error === null &&
              response.payload &&
              response.payload.valid === false
            ) {
              return {
                error: null,
                payload: { code: "pending", dns: domain.data() },
              };
            } else if (
              response.error === null &&
              response.payload &&
              response.payload.valid === true
            ) {
              return {
                error: null,
                payload: { code: "success", domain: domain.data().domain },
              };
            } else {
              throw "Error";
            }
          }
        } else {
          throw "Error";
        }
      } else {
        const channel = await database
          .collection("companies")
          .doc(details.companyId)
          .collection("channels")
          .doc(details.channelId)
          .get();

        const request = await fetch(
          `/api/twilio/fetch-numbers/${details.companyId}/${details.channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const response = await request.json();

        if (response.error === null) {
          return { error: null, payload: { number: response.payload } };
        } else {
          throw "Error";
        }
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveChannelStatus = async (details) => {
  try {
    if (
      details.companyId &&
      details.channelId &&
      details.username &&
      details.type
    ) {
      if (details.type === "email") {
        const request = await fetch(
          `/api/sendgrid/fetch-status/${details.companyId}/${details.channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const response = await request.json();

        if (response.error === null) {
          return { error: null, payload: response.payload };
        } else {
          throw "Error";
        }
      } else {
        const request = await fetch(
          `/api/twilio/fetch-status/${details.companyId}/${details.channelId}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const response = await request.json();
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveEmails = async (info) => {
  try {
    const emailsList = [];
    const allEmails = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("channels")
      .doc(info.channelId)
      .collection("emails")
      .orderBy("timestamp")
      .get();
    if (allEmails.size > 0) {
      allEmails.forEach((email) => {
        const single = fetchEmail(email.id, email.data());
        emailsList.push(single);
      });
    }
    return Promise.all(emailsList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchEmail = (emailId, details) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(details.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            timestamp: details.timestamp,
            snapshot: details.snapshot,
            reach: details.reach,
            contactList: details.contactList,
            template: details.template,
            subject: details.subject,
            sender: details.sender,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
            id: emailId,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const addNewEmailChannel = async (info) => {
  try {
    if (info.details && info.companyId) {
      const companyRef = await database
        .collection("companies")
        .doc(info.companyId)
        .get();

      const details = info.details;
      details.companyId = info.companyId;
      details.addedBy = auth().currentUser?.uid;

      const request = await fetch("/api/sendgrid/create-channel/email", {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });

      const response = await request.json();

      if (
        response.payload &&
        Object.keys(response.payload).length > 0 &&
        !response.error
      ) {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke legge til kanal.";
      }
    } else {
      throw "Kunne ikke legge til kanal.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteEmailChannelDomain = async (details) => {
  try {
    if (details.channelId && details.companyId && details.username) {
      const domainRef = await database
        .collection("companies")
        .doc(details.companyId)
        .collection("channels")
        .doc(details.channelId)
        .collection("domain")
        .doc("information")
        .get();
      if (domainRef.exists) {
        const domainId = domainRef.data().id;

        const request = await fetch(
          `/api/sendgrid/delete-domain/${domainId}/${details.username}/${details.companyId}/${details.channelId}`,
          {
            method: "DELETE",
            body: JSON.stringify(details),
            headers: { "Content-Type": "application/json" },
          }
        );
        const response = await request.json();

        return { error: null, payload: "success" };
      } else {
        throw "Du har ikke satt opp noe domenet.";
      }
    } else {
      throw "Kunne ikke slette domenet.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const addNewSmsChannel = async (info) => {
  try {
    if (info.details && info.companyId) {
      const details = info.details;
      details.companyId = info.companyId;
      details.addedBy = auth().currentUser?.uid;

      const request = await fetch("/api/twilio/create-channel/sms", {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null) {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke legge til ny kanal";
      }
    } else {
      throw "Kunne ikke legge til kanal.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveDistributionSelections = async (info) => {
  try {
    if (info.companyId) {
      const contactLists = [];
      const templates = [];

      const allContactLists = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("contactLists")
        .get();
      const allTemplates = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("templates")
        .where("type", "==", info.type)
        .get();

      allContactLists.forEach((singleContactList) => {
        contactLists.push({
          id: singleContactList.id,
          title: singleContactList.data().name,
        });
      });

      allTemplates.forEach((singleTemplate) => {
        templates.push({
          id: singleTemplate.id,
          title: singleTemplate.data().title,
        });
      });

      return Promise.all([contactLists, templates]).then((result) => {
        return {
          payload: { contactLists: result[0], templates: result[1] },
          error: null,
        };
      });
    } else {
      throw "Kunne ikke hente valg.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const sendBulkEmails = async (info) => {
  try {
    if (
      info.channelId &&
      info.companyId &&
      info.contactList &&
      info.template &&
      info.sender &&
      info.subject &&
      info.username
    ) {
      const request = await fetch("/api/sendgrid/distribute", {
        method: "POST",
        body: JSON.stringify(info),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null) {
        await database
          .collection("companies")
          .doc(info.companyId)
          .collection("channels")
          .doc(info.channelId)
          .collection("emails")
          .add({
            timestamp: moment().unix(),
            snapshot: response.payload.snapshot,
            reach: response.payload.reach,
            contactList: info.contactList,
            template: info.template,
            subject: info.subject,
            sender: info.sender,
            addedBy: auth().currentUser.uid,
          });

        return { payload: "success", error: null };
      } else {
        console.log("Får error fra backend.");
        throw "Kunne ikke sende e-poster.";
      }
    } else {
      console.log("Kunne ikke finne alle verdiene som kreves.");
      throw "Kunne ikke sende e-post.";
    }
  } catch (e) {
    console.log(e, "er feilen");
    throw new Error(e);
  }
};

export const sendBulkSms = async (info) => {
  try {
    if (info.channelId && info.companyId && info.contactList && info.template) {
      const request = await fetch("/api/twilio/distribute", {
        method: "POST",
        body: JSON.stringify(info),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null) {
        await database
          .collection("companies")
          .doc(info.companyId)
          .collection("channels")
          .doc(info.channelId)
          .collection("sms")
          .add({
            timestamp: moment().unix(),
            snapshot: response.payload.snapshot,
            reach: response.payload.reach,
            contactList: info.contactList,
            template: info.template,
            sender: info.sender,
            addedBy: auth().currentUser.uid,
          });

        return { payload: "success", error: null };
      } else {
        throw "Kunne ikke sende SMS.";
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const authenticateDomain = async (info) => {
  try {
    if (info.domain && info.username && info.companyId && info.channelId) {
      const request = await fetch("/api/sendgrid/authenticate-domain", {
        method: "POST",
        body: JSON.stringify(info),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null && Object.keys(response.payload).length > 0) {
        return { payload: response.payload, error: null };
      } else {
        throw "Kunne ikke verifisere domenet.";
      }
    } else {
      throw "Kunne ikke verifisere domenet.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const validateDomain = async (info) => {
  try {
    if (info.id && info.username) {
      const request = await fetch("/api/sendgrid/validate-domain", {
        method: "POST",
        body: JSON.stringify(info),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null && response.payload.valid === true) {
        return { payload: "success", error: null };
      } else {
        return { payload: null, error: "invalid" };
      }
    } else {
      throw "Kunne ikke verifisere domenet.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const changeMailPlan = async (details) => {
  try {
    if (details.companyId && details.channelId && details.channelRef) {
      const request = await fetch("/api/stripe/upgrade-mail-plan", {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null) {
        return { payload: "success", error: null };
      } else {
        return { payload: null, error: "invalid" };
      }
    } else {
      throw "Kunne ikke oppgradere rekkevidde.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const purchaseNumber = async (details) => {
  try {
    if (details.companyId && details.channelId && details.number) {
      const request = await fetch(`/api/stripe/purchase-number`, {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null && response.payload === "success") {
        return { error: null, payload: "success" };
      } else {
        throw "Kunne ikke kjøpe nummer.";
      }
    } else {
      throw "Kunne ikke kjøpe nummer.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteEmailChannel = async (details) => {
  try {
    if (details.channelId && details.companyId && details.username) {
      const request = await fetch(
        `/api/sendgrid/delete-channel/email/${details.companyId}/${details.channelId}`,
        {
          method: "DELETE",
          body: JSON.stringify(details),
          headers: { "Content-Type": "application/json" },
        }
      );
      const response = await request.json();

      if (!response.error && response.payload === "success") {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke slette kanal.";
      }
    } else {
      throw "Kunne ikke slette kanal.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveNumbersAvailable = async (details) => {
  try {
    if (details.companyId && details.channelId && details.search.country) {
      const request = await fetch(
        `/api/twilio/sms-number-options/${details.companyId}/${details.channelId}/${details.search.country}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );
      const response = await request.json();
      if (response.error === null) {
        return { error: null, payload: response.payload };
      } else {
        throw "Kunne ikke hente seleksjoner.";
      }
    } else {
      throw "Kunne ikke hente seleksjoner.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSmsChannelNumber = async (details) => {
  try {
    if (details.channelId && details.companyId) {
      const request = await fetch(
        `/api/twilio/delete-number/${details.companyId}/${details.channelId}`,
        {
          method: "DELETE",
          body: JSON.stringify(details),
          headers: { "Content-Type": "application/json" },
        }
      );
      const response = await request.json();
      if (response.error === null) {
        return { error: null, payload: "success" };
      } else {
        throw "Kunne ikke slette nummer";
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const changeSmsPlan = async (details) => {
  try {
    if (details.companyId && details.channelRef) {
      const request = await fetch("/api/stripe/upgrade-sms-plan", {
        method: "POST",
        body: JSON.stringify(details),
        headers: { "Content-Type": "application/json" },
      });
      const response = await request.json();

      if (response.error === null) {
        return { payload: "success", error: null };
      } else {
        return { payload: null, error: "invalid" };
      }
    } else {
      throw "Kunne ikke oppgradere rekkevidde.";
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveSms = async (info) => {
  try {
    const smsList = [];
    const allSms = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("channels")
      .doc(info.channelId)
      .collection("sms")
      .orderBy("timestamp")
      .get();
    if (allSms.size > 0) {
      allSms.forEach((sms) => {
        const single = fetchSms(sms.id, sms.data());
        smsList.push(single);
      });
    }
    return Promise.all(smsList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchSms = (smsId, details) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(details.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            timestamp: details.timestamp,
            snapshot: details.snapshot,
            reach: details.reach,
            contactList: details.contactList,
            template: details.template,
            sender: details.sender,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
            id: smsId,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};
